module.exports = __webpack_public_path__ + "static/media/Einzelbestellung.1ff669ad.png";